import { Component, Input, OnChanges } from '@angular/core';
import { Automation } from '@core/typings/ui/automation.typing';
import { RuleAutomationService } from '../rule-automation.service';

@Component({
  selector: 'gc-automation-rule-summary',
  templateUrl: './automation-rule-summary.component.html',
  styleUrls: ['./automation-rule-summary.component.scss']
})
export class AutomationRuleSummaryComponent implements OnChanges {
  @Input() uiRules: Automation.CriteriaFormState[];
  ruleSummary: string[];

  constructor (
    private ruleAutomationService: RuleAutomationService
  ) { }

  ngOnChanges () {
    this.ruleSummary = this.uiRules.filter((rule) => {
      return !rule.isRemoved;
    }).map((rule) => {
      if (rule.column) {
        return this.ruleAutomationService.createRuleSentence(rule);
      }

      return '';
    });
  }
}
